import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Clock, Shield, CreditCard, ArrowRight } from 'lucide-react';

const TrialExpiredPage = () => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('razorpay');

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-full max-w-lg px-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/salesqualifyd-logo.png" alt="Salesqualifyd" className="h-14 mx-auto" />
        </div>

        <Card className="border shadow-lg overflow-hidden" style={{ background: 'white' }}>
          {/* Header Banner */}
          <div className="py-8 px-6 text-center" style={{ background: 'linear-gradient(135deg, #8B1A1A, #330066)' }}>
            <div className="mx-auto w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mb-4">
              <Clock className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-white" data-testid="trial-expired-title">Your Trial Has Ended</h2>
            <p className="text-white/80 mt-2 text-sm">Don't worry — all your data is safely stored</p>
          </div>

          <CardContent className="p-6 space-y-6">
            {/* Value proposition */}
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50">
                <Shield className="w-5 h-5 mt-0.5 shrink-0" style={{ color: '#059669' }} />
                <div>
                  <p className="font-medium text-sm text-gray-900">Your data is safe</p>
                  <p className="text-xs text-gray-600">All projects, contacts, and campaigns are securely retained. Subscribe to pick up right where you left off.</p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="space-y-3">
              <Button
                data-testid="subscribe-now-btn"
                className="w-full font-semibold text-white py-6 text-base"
                style={{ background: '#8B1A1A' }}
                onClick={() => navigate('/pricing')}
              >
                <CreditCard className="w-5 h-5 mr-2" />
                View Plans & Subscribe
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>

              <p className="text-center text-sm text-gray-600">
                Want a discount code? Contact{' '}
                <a href="mailto:support@salesqualifyd.com" className="font-semibold underline" style={{ color: '#8B1A1A' }}>
                  support@salesqualifyd.com
                </a>
              </p>
            </div>

            <div className="border-t pt-4">
              <button
                data-testid="trial-expired-logout-btn"
                onClick={handleLogout}
                className="w-full text-center text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                Log out
              </button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TrialExpiredPage;
